import React from 'react';
import { IDropdownItemBaseProps } from '../DropdownItem/DropdownBaseItem';
import { DropdownItem } from '../DropdownItem/DropdownItem';
import { MATERIAL_ICONS } from '../../components/Icon/icons';

interface IMenuItemProps extends React.PropsWithChildren, IDropdownItemBaseProps {
  openInNew?: boolean;
  inlineNesting?: boolean;
}

export const MenuItem = React.forwardRef<HTMLButtonElement, IMenuItemProps>(({ openInNew, postTrailingIcon, ...rest }, ref) => {
  return (
    <DropdownItem
      ref={ref}
      key={rest.key ?? rest.label}
      {...rest}
      postTrailingIcon={openInNew && !postTrailingIcon ? { name: MATERIAL_ICONS.OpenInNew, type: 'outline' } : postTrailingIcon}
    />
  );
});

export const MenuItemOpenInNew = React.forwardRef<HTMLButtonElement, Omit<IMenuItemProps, 'openInNew'>>(({ ...rest }, ref) => {
  return <MenuItem ref={ref} key={rest.key ?? rest.label} {...rest} openInNew />;
});
